import { useMemo, useState } from 'react';
import { createContext } from '@allergan-data-labs/alle-elements-core';

export const useInputSelectState = () => {
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
  const [shouldFocusInput, setShouldFocusInput] = useState(false);

  const value = useMemo(
    () => ({
      focusedIndex,
      shouldFocusInput,
      setShouldFocusInput,
      setFocusedIndex,
    }),
    [focusedIndex, shouldFocusInput, setShouldFocusInput, setFocusedIndex]
  );
  return value;
};

export type InputSelectContextProps = ReturnType<typeof useInputSelectState>;

export const [InputSelectProvider, useInputSelectContext] =
  createContext<InputSelectContextProps>({
    requiresProvider: true,
    name: 'InputSelectContext',
  });
